import { z } from 'zod';
import { Form, TextField, FormActions } from '@/components/form';
import { useLogin } from './use-auth';

const loginSchema = z.object({
  email: z.string().email('Email invalido'),
  password: z.string().min(8, 'Minimo 8 caracteres'),
});

type LoginValues = z.infer<typeof loginSchema>;

export function LoginPage(): JSX.Element {
  const login = useLogin();

  return (
    <div className="min-h-screen flex items-center justify-center bg-muted/30 p-4">
      <div className="w-full max-w-sm rounded-lg border bg-card p-8 shadow-sm">
        <div className="mb-6">
          <h1 className="text-2xl font-semibold tracking-tight">Iniciar sesion</h1>
          <p className="text-sm text-muted-foreground mt-1">Accede a tu cuenta de fact.</p>
        </div>

        <Form<LoginValues>
          schema={loginSchema}
          defaultValues={{ email: '', password: '' }}
          onSubmit={(values) => login.mutate(values)}
          className="space-y-4"
        >
          <TextField<LoginValues>
            name="email"
            label="Email"
            type="email"
            autoComplete="email"
            required
          />
          <TextField<LoginValues>
            name="password"
            label="Contrasena"
            type="password"
            autoComplete="current-password"
            required
          />
          <FormActions submitLabel="Ingresar" isSubmitting={login.isPending} />
        </Form>
      </div>
    </div>
  );
}
